import { StrictMode,Suspense,lazy } from 'react';
import { createRoot } from 'react-dom/client';
import {MarketProvider,useMarket} from './MarketContext';
import './styles.css';
import './markets.css';
import './market-theme.css';
import './admin.css';
import './strategy-settings.css';
import {AuthProvider} from './AuthContext';
import {IS_MAINLINE} from './routing';

const root = document.getElementById('root');
if (!root) throw new Error('TradingMagician root element is missing.');

const App=lazy(()=>import('./App').then(m=>({default:m.App}))),CnApp=lazy(()=>import('./CnApp').then(m=>({default:m.CnApp})));
const NextApp=lazy(()=>import('./NextApp').then(m=>({default:m.NextApp})));
function MarketApp(){return <Suspense fallback={<div className="load-state">正在打开市场工作区…</div>}>{useMarket().market==='cn'?<CnApp/>:<App/>}</Suspense>;}
createRoot(root).render(
  <StrictMode>
    <AuthProvider>{IS_MAINLINE?<Suspense fallback={<div className="load-state">正在打开主线工作区…</div>}><NextApp/></Suspense>:<MarketProvider><MarketApp/></MarketProvider>}</AuthProvider>
  </StrictMode>,
);
